// @flow

import React from 'react';
import bemify from 'bemify-js';

import { Icon } from '@zapier/common-components';

import Link from 'web-ssr/app/common/components/Link';
import 'web-ssr/app/common/components/ContentFooter/SocialLinks.scss';

const bem = bemify('social-links');

type Props = {
  className?: string,
};

const SocialLinks = (props: Props) => {
  const { className } = props;

  return (
    <div className={bem(className)}>
      <Link
        className={bem('__link')}
        href="http://www.facebook.com/ZapierApp?utm_source=zapier.com&amp;utm_medium=referral&amp;utm_campaign=zapier"
        title="Follow us on Facebook"
      >
        <Icon name="facebook" />
      </Link>

      <Link
        className={bem('__link')}
        href="http://www.linkedin.com/company/zapier/?utm_source=zapier.com&amp;utm_medium=referral&amp;utm_campaign=zapier"
        title="Follow us on LinkedIn"
      >
        <Icon name="linkedin" />
      </Link>

      <Link
        className={bem('__link')}
        href="https://twitter.com/?utm_source=zapier.com&amp;utm_medium=referral&amp;utm_campaign=zapier#!/zapier"
        title="Follow @zapier on Twitter"
      >
        <Icon name="social-twitter" />
      </Link>

      <Link
        className={bem('__link')}
        href="http://www.youtube.com/user/ZapierApp/videos?utm_source=zapier.com&amp;utm_medium=referral&amp;utm_campaign=zapier"
        title="See helpful Zapier videos on Youtube"
      >
        <Icon name="youtube" />
      </Link>

      <Link
        className={bem('__link')}
        href="/blog/feeds/latest/"
        title="Subscribe to our blog"
      >
        <Icon name="rss" />
      </Link>
    </div>
  );
};

export default SocialLinks;
